import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { PsLabel } from "../../../components";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { formToObject, lowerCase } from "../../../utils";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { _LIST_USER_ROLES } from "../../../models/rbacModel";
import { _SAVE_USER_LOGIN } from "../../../models/userLoginModel";
import { _LIST_AGENCIES } from "../../../models/agenciesModel";

const AddUserLoginFormComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [roles, setRoles] = useState([]);
  const [agents, setAgents] = useState([]);

  const { openDialog } = useDialog();

  useEffect(() => {
    listRoles();
    listAgencies();
  }, []);

  const listRoles = () => {
    setLoader(true);
    _LIST_USER_ROLES({ status: "1" }).then((res) => {
      if (res.status == "1") {
        setRoles(res.data);
      } else {
        setRoles([]);
      }
      setLoader(false);
    });
  };

  const listAgencies = () => {
    setLoader(true);
    _LIST_AGENCIES({ status: "1" }).then((res) => {
      if (res.status == "1") {
        setAgents(res.data);
      } else {
        setAgents([]);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _SAVE_USER_LOGIN(formToObject(form)).then((res) => {
      if (res.status == "1") {
        form.reset();
        context.setAlertMsg(res.message || "Saved");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Save",
        });
      }
      setLoader(false);
    });
  };

  const handleUserNameBlur = (e) => {
    let str = e.target.value;
    if (str) {
      str = str.replace(/[^a-zA-Z0-9_]/g, "");
      e.target.value = lowerCase(str);
    }
  };

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          {!props.agencyId ? (
            <Row>
              <Col md={3}>
                <PsLabel text="Agency" required />
              </Col>
              <Col md={9}>
                <Form.Control
                  as="select"
                  name="agent_id"
                  size="sm"
                  className="fw-bold form-select form-select-sm"
                  required
                  autoFocus
                >
                  <option value="">-Select-</option>
                  {agents.map((item) => (
                    <option value={item.id}>
                      {item.company_name}
                      {" - "}
                      {item.mobile_no}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          ) : (
            <input type="hidden" name="agent_id" value={props.agencyId} />
          )}
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Name" required />
            </Col>
            <Col md={3} className="pe-0">
              <Form.Control
                as="select"
                name="title"
                size="sm"
                className="fw-bold form-select form-select-sm"
                autoFocus
                required
              >
                <option value="M/s">M/s</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Dr">Dr</option>
                <option value="Master">Master</option>
              </Form.Control>
            </Col>
            <Col md={6} className="ps-0">
              <Form.Control
                type="text"
                name="name"
                placeholder="Name"
                size="sm"
                className="fw-bold"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Mobile" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="number"
                name="mobile"
                placeholder="Mobile"
                size="sm"
                className="fw-bold"
                min="0"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Email" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="email"
                name="email"
                placeholder="Mail Id"
                size="sm"
                className="fw-bold"
                autoComplete="off"
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Commission" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="percentage_of_commision"
                placeholder="% of Commission"
                size="sm"
                className="fw-bold"
                autoComplete="off"
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={12} className="bg-silver-50 mb-2">
              <ul>
                <li>
                  Can include letters (a-z, A-Z), numbers (0-9), and underscores
                  (_).
                </li>
                <li>No special characters like !@#$%^&*().</li>
                <li>
                  The username must start with a letter (not a number or symbol)
                </li>
                <li>Spaces are not allowed in the username.</li>
                <li>
                  Do not use inappropriate or offensive language in the
                  username.
                </li>
              </ul>
            </Col>
            <Col md={3}>
              <PsLabel text="Username" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="username"
                placeholder="Username"
                size="sm"
                className="fw-bold"
                autoComplete="off"
                onBlur={(e) => handleUserNameBlur(e)}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Password" required />
            </Col>
            <Col md={9}>
              <InputGroup size="sm">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  size="sm"
                  className="fw-bold"
                  autoComplete="off"
                  required
                />
                <InputGroup.Text
                  className="cursor-pointer"
                  onClick={(e) => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <VisibilityOffIcon fontSize="small" />
                  ) : (
                    <VisibilityIcon fontSize="small" />
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Role" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="select"
                name="role_uid"
                size="sm"
                className="fw-bold form-select form-select-sm"
                autoFocus
                required
              >
                <option value="">-Select-</option>
                {roles.map((item) => (
                  <option value={item.id}>{item.role_name}</option>
                ))}
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const AddUserLoginForm = (props) => {
  return (
    <>
      <PsModalWindow size="md" title="New User Login" {...props}>
        {props.show && <AddUserLoginFormComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default AddUserLoginForm;
